import { createContext } from 'react';

const LocalizationContext = createContext();

export default LocalizationContext